const priorityProjects = [
  {
    id: 'membership',
    summary: 'Membership — Annual ($150/yr) or Life ($1,500)',
    title: '1. Membership — Join & Support the North America Chapter',
    paragraphs: [
      'The foundation of everything we do as a chapter is our membership. By joining LITAA, you become part of a global community of over 6,000 alumni, support the association\'s activities and administration, and demonstrate to our alma mater that its North American alumni are organized, engaged, and committed. Life membership carries special recognition within the broader LITAA community.',
    ],
    bullets: [
      { strong: 'Annual Membership', text: '$150 per year' },
      { strong: 'Life Membership', text: '$1,500 one-time fee — with enhanced recognition and acknowledgment' },
    ],
    contactLabel: 'Contact us to join',
    contactPath: '/contactus',
  },
  {
    id: 'gold-medals',
    summary: 'Gold Medals for Outstanding Students — $500/yr per medal',
    title: '2. Gold Medals for Outstanding LITU Students',
    paragraphs: [
      'LITU\'s eight academic disciplines — Chemical Engineering, Food Technology, Petroleum Refining & Petrochemical Technology, Surface Coating Technology, Polymer Technology, Paint Technology, Biotechnology, and Microbiology/Biochemistry — each offer undergraduate and postgraduate programs. A total of 16 gold medals can be awarded annually, one for the top student in each program.',
    ],
    bullets: [
      { strong: 'Cost', text: '$500 per year, per medal | 10-year commitment recommended: $5,000 total' },
      { text: 'Each medal is awarded in the name chosen by the donor — honoring the donor, a mentor, a parent, or anyone whose memory they wish to carry forward.' },
    ],
    footnote: 'Contributions may be made in your name or in honor of someone you wish to recognize.',
    contactLabel: 'Contact us to sponsor a gold medal',
    contactPath: '/contactus',
  },
  {
    id: 'library',
    summary: 'LITU Library Modernization — $36,000 full project',
    title: '3. LITU Library Modernization',
    paragraphs: [
      'LITAA has already invested in automating the library\'s functions and installing modern security systems. The next phase is a physical transformation: replacing old furniture with modern, modular seating and study spaces, and installing 10 air conditioning units to make the library a comfortable, year-round study environment.',
    ],
    bullets: [
      { strong: 'Total Budget', text: '$36,000 (approx. ₹30 lakh) — full project | Partial contributions welcome' },
      { text: 'The renovated library may be named in honor of the lead donor or anyone they wish to memorialize.' },
    ],
    contactLabel: 'Contact us to support the library',
    contactPath: '/contactus',
  },
  {
    id: 'scholarships',
    summary: 'Merit Scholarships — $1,000 per student per year',
    title: '4. Merit Scholarships for Financially Deserving LITU Students',
    paragraphs: [
      'Among the most urgent needs brought forward by Vice Chancellor Dr. Atul Vaidya is a group of academically qualified students who earned admission to LITU on merit — but whose families cannot afford the annual tuition.',
    ],
    bullets: [
      { strong: 'Cost', text: '$1,000 per student per year (approx. ₹90,000)' },
      { text: '$4,000 per student for a full 4-year degree' },
      { text: '~$50,000 to fully sponsor the current cohort of 12 students' },
    ],
    footnote: 'Scholarship contributions may be made in honor of a person of the donor\'s choosing.',
    contactLabel: 'Contact us to sponsor a student',
    contactPath: '/contactus',
  },
  {
    id: 'washrooms',
    summary: 'Campus Washroom Upgrades — $36,000 remaining balance',
    title: '5. LITU Campus Washroom Upgrades — Academic Buildings',
    paragraphs: [
      'The washrooms in LITU\'s academic buildings are decades old and in need of complete renovation. With 40% of current students being women, upgrading the ladies\' facilities is the stated priority. The project will renovate 24 toilet facilities across five academic buildings, modernizing the stalls, increasing capacity, and improving hygiene and safety for students.',
    ],
    bullets: [
      { strong: 'Remaining Budget Needed', text: '$36,000 (approx. ₹30 lakh)' },
      { text: 'Approximately half of the total project cost has already been raised from alumni within India' },
    ],
    contactLabel: 'Contact us to contribute',
    contactPath: '/contactus',
  },
  {
    id: 'e-classrooms',
    summary: 'Smart E-Classrooms in the Heritage Building — $36,000 per room',
    title: '6. LITU Smart E-Classrooms — Heritage Building',
    paragraphs: [
      'The main heritage building — the iconic structure that virtually every LITian carries in their memory — is over 80 years old. Structural engineers from VNIT have assessed the building and developed a plan that will extend its life by an estimated 25 years, while simultaneously transforming it into a modern teaching environment.',
    ],
    bullets: [
      { strong: 'Cost per Room', text: '$36,000 per room (approx. ₹30 lakh) | 2 classrooms still available for sponsorship' },
      { text: 'Air conditioning units have already been funded through a generous donation from an alumnus' },
    ],
    footnote: 'Each sponsored classroom will carry a permanent dedication in the name of the donor\'s choosing.',
    contactLabel: 'Contact us to sponsor a classroom',
    contactPath: '/contactus',
  },
  {
    id: 'hostel',
    summary: 'Hostel Repairs — ₹15 lakh per hostel',
    title: '7. Hostel Repairs',
    paragraphs: [
      'Current hostels are not included in government grants and need:',
    ],
    bullets: [
      { text: 'Washroom repairs' },
      { text: 'Repainting, waterproofing' },
      { text: 'New fans, doors, beds, and furniture' },
      { strong: 'Estimated cost', text: '₹15 lakh per hostel' },
    ],
    contactLabel: 'Contact us to contribute',
    contactPath: '/contactus',
  },
  {
    id: 'govt-funding',
    summary: 'Government Funding Timeline',
    title: '8. Government Funding Timeline',
    paragraphs: [
      'Govt. funding is only for new buildings and select hostels for reserved categories, not for current buildings nor for general category student hostels.',
    ],
    bullets: [
      { text: 'Construction start: ~2029' },
      { text: 'Full completion: ~2035' },
      { text: 'Alumni donations are vital to bridge the compatibility gap for existing hostel buildings, academic buildings and the time lag between now and project completion.' },
    ],
    contactLabel: 'Contact us to learn more',
    contactPath: '/contactus',
  },
];

export default priorityProjects;
